import { CombinedGraphQLErrors } from '@apollo/client'

/**
 * Pulls a human-readable message out of a rejected mutation. Apollo Client 4
 * rejects with CombinedGraphQLErrors, which carries the server's errors as
 * `errors` rather than on the error itself.
 */
export const getMutationErrorMessage = (error: unknown): string | undefined => {
  if (CombinedGraphQLErrors.is(error)) {
    return error.errors[0]?.message
  }
  return error instanceof Error ? error.message : undefined
}
